import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class ListClientsSocisService {
  public activeFilters: any = {};
  public valFiltres = {};
  public currentPage: number = 0;
  public rowsPerPage: number = 20;

  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  constructor() { }
}
